<template>
  <div
    class="vertical-layout h-100"
    :class="[layoutClasses]"
    :data-col="isNavMenuHidden ? '1-column' : null"
  >
    <!-- Navbar -->
    <b-navbar
      :toggleable="false"
      :variant="navbarBackgroundColor"
      class="header-navbar navbar navbar-shadow align-items-center"
      :class="[navbarTypeClass]"
    >
      <slot
        name="navbar"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :navbarBackgroundColor="navbarBackgroundColor"
        :navbarTypeClass="[...navbarTypeClass, 'header-navbar navbar navbar-shadow align-items-center']"
      >
        <app-navbar-vertical-layout :toggle-vertical-menu-active="toggleVerticalMenuActive" />
      </slot>
    </b-navbar>
    <!--/ Navbar -->

    <!-- Vertical Nav Menu -->
    <vertical-nav-menu
      v-if="!isNavMenuHidden"
      :is-vertical-menu-active="isVerticalMenuActive"
      :toggle-vertical-menu-active="toggleVerticalMenuActive"
    >
      <template #header="slotProps">
        <slot
          name="vertical-menu-header"
          v-bind="slotProps"
        />
      </template>
    </vertical-nav-menu>
    <!-- /Vertical Nav Menu -->

    <!-- Vertical Nav Menu Overlay -->
    <div
      class="sidenav-overlay"
      :class="overlayClasses"
      @click="isVerticalMenuActive = false"
    />
    <!-- /Vertical Nav Menu Overlay -->

    <!-- Content -->

    <!-- CONTENT TYPE: Left -->
    <transition
      :name="routerTransition"
      mode="out-in"
    >
      <component
        :is="layoutContentRenderer"
        :key="layoutContentRenderer === 'layout-content-renderer-left' ? $route.meta.navActiveLink || $route.name : null"
      >
        <template
          v-for="(index, name) in $scopedSlots"
          v-slot:[name]="data"
        >
          <slot
            :name="name"
            v-bind="data"
          />
        </template>
      </component>
    </transition>
    <!--/ Content -->

    <!-- Footer -->
    <footer
      class="footer footer-light"
      :class="[footerTypeClass]"
    >
      <slot name="footer">
        <app-footer />
      </slot>
    </footer>
    <!-- /Footer -->

    <slot name="customizer" />
  </div>
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import AppNavbarVerticalLayout from '@core/layouts/components/app-navbar/AppNavbarVerticalLayout.vue'
import AppFooter from '@core/layouts/components/AppFooter.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { BNavbar } from 'bootstrap-vue'
import LayoutContentRendererDefault from '@core/layouts/components/layout-content-renderer/LayoutContentRendererDefault.vue'
import LayoutContentRendererLeft from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeft.vue'
import LayoutContentRendererLeftDetached from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeftDetached.vue'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import useVerticalLayout from './useVerticalLayout'
import mixinVerticalLayout from './mixinVerticalLayout'

export default {
  components: {
    // AppBreadcrumb,
    AppNavbarVerticalLayout,
    AppFooter,
    VerticalNavMenu,
    BNavbar,
    LayoutContentRendererLeftDetached,
    LayoutContentRendererLeft,
    LayoutContentRendererDefault,
  },
  mixins: [mixinVerticalLayout],
  computed: {
    layoutContentRenderer() {
      const rendererType = this.$route.meta.contentRenderer
      if (rendererType === 'sidebar-left') return 'layout-content-renderer-left'
      if (rendererType === 'sidebar-left-detached') return 'layout-content-renderer-left-detached'
      return 'layout-content-renderer-default'
    },
  },
  setup() {
    const {
      routerTransition, navbarBackgroundColor, navbarType, footerType, isNavMenuHidden,
    } = useAppConfig()

    const {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      layoutClasses,
      overlayClasses,
      resizeHandler,
      navbarTypeClass,
      footerTypeClass,
    } = useVerticalLayout(navbarType, footerType)

    // Resize handler
    resizeHandler()
    window.addEventListener('resize', resizeHandler)
    onUnmounted(() => {
      window.removeEventListener('resize', resizeHandler)
    })

    return {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      overlayClasses,
      layoutClasses,
      navbarTypeClass,
      footerTypeClass,

      // App Config
      routerTransition,
      navbarBackgroundColor,
      isNavMenuHidden,
    }
  },
  mounted() {
    this.getNotification()
    setTimeout(() => {
      this.getNotificationWithdraw()
      this.getNotificationTransactionHistory()
    }, 1000)
    setInterval(() => {
      this.getNotification()
    }, 15000)
    setInterval(() => {
      this.getNotificationWithdraw()
    }, 25000)
    setInterval(() => {
      this.getNotificationRenewalTransactions()
    }, 600000)
  },
  methods: {
    async getNotification() {
      try {
        const notificationBadge = document.getElementById('notificationTicket')
        const response = await this.$http.get('super-admin/notifications/ticket-count')
        const { count } = response.data.data
        notificationBadge.textContent = count
        if (count === 0) {
          notificationBadge.style.opacity = 0
        } else {
          notificationBadge.style.opacity = 1
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getNotificationWithdraw() {
      try {
        const notificationWithdraw = document.getElementById('notificationWithdraw')
        const notificationAffiliate = document.getElementById('notificationAffiliate')

        const response = await this.$http.get('super-admin/withdraw-notification-count')
        const { count } = response.data.data

        notificationWithdraw.textContent = count
        console.log(count, 'COINT');
        if (count === 0) {
          notificationWithdraw.style.opacity = 0
          notificationAffiliate.style.opacity = 0
        }
        if (count > 0) {
          notificationWithdraw.style.opacity = 1
          notificationAffiliate.style.opacity = 1
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getNotificationTransactionHistory() {
      const notificationTransactionHistoryBadge = document.getElementById('notificationTransactionHistory')
      notificationTransactionHistoryBadge.style.opacity = 0

      const renewals = await this.getNotificationRenewalTransactions()
      const credits = await this.getNotificationCreditTransactions()

      console.log('renewals:', renewals)
      console.log('credits:', credits)

      if ((renewals + credits) > 0) {
        notificationTransactionHistoryBadge.textContent = '!'
        notificationTransactionHistoryBadge.style.opacity = 1
      } else {
        notificationTransactionHistoryBadge.style.opacity = 0
      }
    },
    async getNotificationRenewalTransactions() {
      let diff = 0
      try {
        const notificationRenewalsBadge = document.getElementById('notificationRenewals')
        notificationRenewalsBadge.style.opacity = 0

        const response = await this.$http.get('super-admin/notifications/renewal-transaction-count')
        const { count } = response.data.data

        const storedData = JSON.parse(localStorage.getItem('renewalTransactions')) || { total: 0, badge: 0 }
        const storedTotal = storedData.total

        if (storedTotal !== count) {
          diff = count - storedTotal

          localStorage.setItem('renewalTransactions', JSON.stringify({
            total: count,
            badge: diff,
          }))

          notificationRenewalsBadge.textContent = diff
          notificationRenewalsBadge.style.opacity = 1
        }
        else {
          notificationRenewalsBadge.style.opacity = 0
        }
      } catch (err) {
        console.log('error notification renewal transactions: ', err)
      }

      return diff
    },
    async getNotificationCreditTransactions() {
      let diff = 0
      try {
        const notificationCreditsBadge = document.getElementById('notificationCredits')
        notificationCreditsBadge.style.opacity = 0

        const response = await this.$http.get('super-admin/notifications/credit-transaction-count')
        const { count } = response.data.data

        const storedData = JSON.parse(localStorage.getItem('creditTransactions')) || { total: 0, badge: 0 }
        const storedTotal = storedData.total

        if (storedTotal !== count) {
          diff = count - storedTotal

          localStorage.setItem('creditTransactions', JSON.stringify({
            total: count,
            badge: diff,
          }))

          notificationCreditsBadge.textContent = diff
          notificationCreditsBadge.style.opacity = 1
        }
        else {
          notificationCreditsBadge.style.opacity = 0
        }
      } catch (err) {
        console.log('error notification credit transactions: ', err)
      }

      return diff
    },
  }
}
</script>

<style lang="scss">
@import "~@core/scss/base/themes/bordered-layout.scss";
</style>
